import { Component, OnInit, TemplateRef } from '@angular/core';
import { Mapping, MappingResponse, AvailResponse } from '../models/mapping';
import { BsModalRef, BsModalService, PageChangedEvent } from 'ngx-bootstrap';
import { UserPage } from '../models/login';
import { ApiService } from '../Services/api-service';
import { ToastrService } from 'ngx-toastr';
import { Product, ProductResponse,tokenStockExcel,tokenStockExcelReport} from '../models/product';
import { PackSize, PackSizeResponse } from '../models/packsize';
import { Denomination, DenominationResponse } from '../models/denomination';
import * as moment from 'moment';
import { StockResponse, Stock, StockFromNumberResponse } from '../models/stock';
import { NgForm } from '@angular/forms';
import { ExcelService } from '../excel.service';
@Component({
  selector: 'app-cn-report',
  templateUrl: './cn-report.component.html',
  styleUrls: ['./cn-report.component.css']
})
export class CNReportComponent implements OnInit {
  pagesUser: UserPage = new UserPage();
  formval: Stock = new Stock();
  cnList:any;
  cnExcelList:any[]=[];
  cnExcelListReport:any[]=[];
  show: boolean = false;
  url: string;
  availableStockExcel:any[]=[];
  availableStockExcelReport:any[]=[];
  totaldata: number;
  // formval: Stock = new Stock();
  submitForm: NgForm;
  checkFromNumber: string;
  checkToNumber: string;
  constructor(private excelService: ExcelService,private toastr: ToastrService, private modalService: BsModalService, private api: ApiService) {
    this.formval.pageNumber=1;
    this.formval.pageSize='5';
    this.pagesUser.Filter='';
    var date = new Date();
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var currentDay = date.getDate();
    this.formval.fromdate = moment(firstDay, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    this.formval.todate = moment(currentDay, "DD-MMM-YYYY").format("DD-MMM-YYYY");
  }

  ngOnInit() {
    this.getCNreportData()
  }
  getCNreportData()
  {
    let obj ={
      pageNumber:this.formval.pageNumber,
      pageSize:this.formval.pageSize,
      FilterBy:'',
      searchValues:'',
      IsActive:'',
      HoUserID:localStorage.getItem("userID"),
      FromDate: this.formval.fromdate,
      ToDate: this.formval.todate
    }
    this.formval.fromdate = moment(this.formval.fromdate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    this.formval.todate = moment(this.formval.todate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    if (moment(this.formval.fromdate).isAfter(this.formval.todate)) {
      this.toastr.warning('From Date should not be greater than To Date!', 'Warning!', {
        timeOut: 3000
      });
    }
    this.api.PostApi(obj,`Report/GetCNreport`).subscribe((resp:any)=>{
      if(resp.ResponseCode==200)
      {
        this.cnList=resp.ResponseData;
        this.totaldata=resp.ResponseData[0].TotalCount;
      }
    })
  }
  pageChanged(event: PageChangedEvent): void {
    const startItem = (event.page - 1) * event.itemsPerPage;
    const endItem = event.page * event.itemsPerPage;
    this.formval.pageNumber = event.page;
    this.getCNreportData();
  }
  ontypechange() {
    this.pagesUser.page = 1
    this.pagesUser.pageSize=this.formval.pageSize;
    this.getCNreportData();
  }
  DownloadCNReport()
  {
    this.cnExcelListReport=[];
    this.cnExcelList=[];
    let obj={
      pageNumber:1,
      pageSize:-1,
      FilterBy:'',
      searchValues:'',
      IsActive:'',
      FromDate: this.formval.fromdate,
      ToDate: this.formval.todate
    }
    this.formval.fromdate = moment(this.formval.fromdate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    this.formval.todate = moment(this.formval.todate, "DD-MMM-YYYY").format("DD-MMM-YYYY");
    if (moment(this.formval.fromdate).isAfter(this.formval.todate)) {
      this.toastr.warning('From Date should not be greater than To Date!', 'Warning!', {
        timeOut: 3000
      });
    }
    this.api.PostApi(obj,`Report/GetCNreport`).subscribe((resp:any)=>{
      if(resp.ResponseCode==200)
      {
        this.cnExcelList=resp.ResponseData;
        this.cnExcelList.forEach(o=>{
          this.cnExcelListReport.push({
            ScannedDate:o.Date,
            SBL:o.SblType,DepotCode:o.DepotCd,DepotName:o.DepotNm,BILL_TO_CODE:o.BillToCode,BILL_TO:o.Bill_To,Customer_Code:o.AccountNo,Firm_Name:o.FirmNm,Contact_Person:o.DealerNm
            ,Sum_of_Denomination_Amount:o.points,
            Service_Charge_10Percent:o.ServiceCharge10per,CN_Amount:o.CNAmount
          })
        })
        this.exportAsXLSX(this.cnExcelListReport);
        this.show = false;
      }
    })
  }
  exportAsXLSX(myreport: any): void {
    this.excelService.exportAsExcelFile(this.cnExcelListReport, 'CN Report');
  }

}
